module.exports = __webpack_public_path__ + "img/sdi_logo.a0f7c9f0.jpg";